import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  search: "",
};

export const taskSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    setSearch: (state, action) => {
      state.search = action.payload;
    },
  },
});

export const { setSearch } = taskSlice.actions;

export default taskSlice.reducer;
